export default {
    root: {
        class: [
            // Flex & Alignment
            'flex items-center flex-wrap',

            // Spacing
            'py-4',

            // Color
            'text-gray-600 text-sm font-bold',
        ],
    },
    first: ({ context }) => ({
        class: [
            'relative',

            // Flex & Alignment
            'inline-flex items-center justify-center',

            // Shape
            'border-0 rounded',

            // Size
            'w-8 h-8',
            'leading-none',

            // Color
            'text-gray-600 bg-gray-50',

            // State
            {
                'hover:bg-gray-200': !context.disabled,
                'focus:outline-none focus:outline-offset-0 focus:ring-2 focus:ring-black': !context.disabled,
            },

            // Transition
            'transition duration-200',

            // Misc
            'select-none overflow-hidden',
            { 'cursor-default pointer-events-none opacity-60': context.disabled },
        ],
    }),
    prev: ({ context }) => ({
        class: [
            'relative',

            // Flex & Alignment
            'inline-flex items-center justify-center',

            // Shape
            'border-0 rounded',

            // Size
            'w-8 h-8',
            'leading-none',

            // Color
            'text-gray-600 bg-gray-50',

            // State
            {
                'hover:bg-gray-200': !context.disabled,
                'focus:outline-none focus:outline-offset-0 focus:ring-2 focus:ring-black': !context.disabled,
            },

            // Transition
            'transition duration-200',

            // Misc
            'select-none overflow-hidden',
            { 'cursor-default pointer-events-none opacity-60': context.disabled },
        ],
    }),
    next: ({ context }) => ({
        class: [
            'relative',

            // Flex & Alignment
            'inline-flex items-center justify-center',

            // Shape
            'border-0 rounded',

            // Size
            'w-8 h-8',
            'leading-none',

            // Color
            'text-gray-600 bg-gray-50',

            // State
            {
                'hover:bg-gray-200': !context.disabled,
                'focus:outline-none focus:outline-offset-0 focus:ring-2 focus:ring-black': !context.disabled,
            },

            // Transition
            'transition duration-200',

            // Misc
            'select-none overflow-hidden',
            { 'cursor-default pointer-events-none opacity-60': context.disabled },
        ],
    }),
    last: ({ context }) => ({
        class: [
            'relative',

            // Flex & Alignment
            'inline-flex items-center justify-center',

            // Shape
            'border-0 rounded',

            // Size
            'w-8 h-8',
            'leading-none',

            // Color
            'text-gray-600 bg-gray-50',

            // State
            {
                'hover:bg-gray-200': !context.disabled,
                'focus:outline-none focus:outline-offset-0 focus:ring-2 focus:ring-black': !context.disabled,
            },

            // Transition
            'transition duration-200',

            // Misc
            'select-none overflow-hidden',
            { 'cursor-default pointer-events-none opacity-60': context.disabled },
        ],
    }),
    page: (ctx) => ({
        class: [
            'relative',

            // Flex & Alignment
            'inline-flex items-center justify-center',

            // Shape
            'border-0 rounded',

            // Size
            'w-8 h-8',
            'leading-none',

            // Color
            'text-gray-600 bg-gray-50',

            // State
            {
                'hover:bg-gray-200': !ctx.context.disabled,
                'focus:outline-none focus:outline-offset-0 focus:ring-2 focus:ring-black': !ctx.context.disabled,
            },

            // Transition
            'transition duration-200',

            // Misc
            'select-none overflow-hidden',
            { 'cursor-default pointer-events-none opacity-60': ctx.context.disabled },
        ],
    }),
    pcJumpToPageInputText: 'pl-8 w-20 rounded border-l border-gray-300 text-center',
    content: 'flex items-center justify-between w-full',
    contentStart: 'mr-auto',
    contentEnd: 'ml-auto',
    pages: 'flex items-center gap-1',
};
